/**
 * Fetches a private file with the caller's auth (e.g. apiClient) and opens it in a new tab.
 */
export async function openAuthenticatedBlobInNewTab(
  fetchBlob: () => Promise<Blob>,
): Promise<void> {
  const blob = await fetchBlob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);
}
